import React from 'react';
import Template from '../../../layout/Template';



const ContasAReceber = () =>{

    return (
        <Template>
            <h3>Contas a Receber</h3>
        </Template>
    )
}
export default ContasAReceber;